import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { SalesPage } from './components/SalesPage';
import { SocialProofPopup } from './components/SocialProofPopup';
// Add types for fbq
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    const initPixel = () => {
      if (window.fbq) return;
      let n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      window.fbq('init', '1429621072242991');
      window.fbq('track', 'PageView');
    };
    initPixel();
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <SalesPage data-id="element-2" />
      <SocialProofPopup data-id="element-3" />
    </div>;
}